import { createBrowserRouter } from 'react-router'

import { LoginPage } from '@/features/auth/LoginPage'
import { ProfilePage } from '@/features/auth/ProfilePage'
import { RegisterPage } from '@/features/auth/RegisterPage'
import { RequireAuth } from '@/features/auth/RequireAuth'
import { CatalogPage } from '@/features/catalog/CatalogPage'
import { NotFoundPage } from '@/features/errors/NotFoundPage'
import { LandingPage } from '@/features/landing/LandingPage'
import { ProgressPage } from '@/features/progress/ProgressPage'
import { TrackPage } from '@/features/tracks/TrackPage'
import { TracksPage } from '@/features/tracks/TracksPage'

import { Layout } from './Layout'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <LandingPage /> },
      { path: 'login', element: <LoginPage /> },
      { path: 'register', element: <RegisterPage /> },
      // Каталог и условие задачи открыты гостю (FR-C1): вход требуется только
      // для запуска запроса и отправки решения — это проверяет TaskPage.
      { path: 'tasks', element: <CatalogPage /> },
      // Треки открыты гостю по той же причине, что и каталог: список шагов —
      // это витрина, прогресс в нём появляется только после входа.
      { path: 'tracks', element: <TracksPage /> },
      { path: 'tracks/:slug', element: <TrackPage /> },
      {
        path: 'tasks/:slug',
        // Отдельным чанком: CodeMirror и рендерер Markdown нужны только здесь,
        // и тянуть их на лендинг и в каталог незачем.
        lazy: async () => {
          const { TaskPage } = await import('@/features/task/TaskPage')
          return { Component: TaskPage }
        },
      },
      {
        path: 'me',
        element: (
          <RequireAuth>
            <ProfilePage />
          </RequireAuth>
        ),
      },
      {
        path: 'progress',
        element: (
          <RequireAuth>
            <ProgressPage />
          </RequireAuth>
        ),
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
])
